import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, Switch } from 'react-router-dom';
import Post from './Post';
import DriveBrowser from "./DriveBrowser"; 
import FirstNews from './FirstNews';
import FileBrowser from "./FileBrowser"; 

const Download = () =>{
    const [files, setFiles] = useState([]);
    

  useEffect(() => {
    const fetchFiles = async () => {
      const response = await fetch('/download/download.json');
      const fileList = await response.json();
      setFiles(fileList);
    };

    fetchFiles();

    
  }, []);


    return(
        <div>
            <div class="ttm-page-title-row">
            <div class="ttm-page-title-row-inner  ttm-bgcolor-darkgrey">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-12" style={{textAlign:'left'}}>
                            <div class="page-title-heading">
                                <h2 class="title">Download</h2>
                            </div>
                            <div class="breadcrumb-wrapper">
                                <span><a class="pathway" href="/">Home</a></span><span><a class="pathway" href="/download"> Download</a></span>                              
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="site-main">
           
            <div class="ttm-row sidebar ttm-sidebar-right ttm-bgcolor-white clearfix" style={{paddingTop: "0px"}}>
                <div class="container">
                   
                    <div class="row">
                    <div class="col-xl-9 col-lg-8 content-area mt-5">
                          
                            <article class="widget widget-download" style={{textAlign:'left'}}>
                        {/* <ul class="download">
                        {files.map( item => (
                            <li><a href={item.url} target='_blank' rel="noopener noreferrer"><i class="fa fa-file-pdf-o"></i>{item.title}</a> </li>
                        ))}
                        </ul> */}
                            <div>
                            {/* <DriveBrowser 
                                apiKey="AIzaSyDTGuWnYrsERgu6hAkSnZep-uswuOMZ_14"
                                rootFolderId="1KHXOEV9Fk0YydYDUeO4X0bjyxOkKgrYT"
                                /> */}
                            
                             <FileBrowser 
                                        folderBase="/documents/kepegawaian/7. BLANGKO"  bag="download"
                            />
                        </div>
                        </article>

                        </div>
                        <div class="col-xl-3 col-lg-4 widget-area sidebar-right ttm-col-bgcolor-yes ttm-bg ttm-right-span ttm-bgcolor-grey pt-60 mb_60 pb-60 res-991-mt-0 res-991-pt-0">
                            <div class="ttm-col-wrapper-bg-layer ttm-bg-layer"></div>

                            <FirstNews />
              </div>
                    </div>
                 
                </div>
            </div>
           

        </div>
        </div>
    );
};

export default Download;